import type { StudioRole } from '@studio/contracts';
import { ROLE_SECTIONS } from '@studio/contracts';

export interface NavItem {
  key: string;
  label: string;
  icon: string;
  to: string;
  /** Screens land phase by phase; the sidebar shows only what is built. */
  built: boolean;
}
export interface NavSection { title: string; items: NavItem[] }

/** Sections and order exactly as on the canvas sidebar (design/canvas/_shell.py NAV). */
export const NAV: NavSection[] = [
  { title: 'Library', items: [
    { key: 'upload', label: 'Upload', icon: 'upload', to: '/upload', built: true },
    { key: 'analyse', label: 'Analyse', icon: 'pulse', to: '/analyse', built: true },
    { key: 'tagging', label: 'Tagging', icon: 'tag', to: '/tagging', built: true },
    { key: 'browse', label: 'Browse', icon: 'grid', to: '/browse', built: true },
    { key: 'collections', label: 'Collections', icon: 'folder', to: '/collections', built: false },
    { key: 'library', label: 'Library', icon: 'archive', to: '/library', built: true },
    { key: 'usage', label: 'Usage log', icon: 'clock', to: '/usage', built: true },
  ] },
  { title: 'Production', items: [
    { key: 'queue', label: 'Queue', icon: 'list', to: '/', built: true },
    { key: 'compose', label: 'Compose', icon: 'film', to: '/compose', built: true },
    { key: 'compose-fast', label: 'Composer Fast', icon: 'film', to: '/compose-fast', built: true },
    { key: 'archive', label: 'Archive', icon: 'save', to: '/archive', built: true },
    { key: 'audio', label: 'Audio', icon: 'music', to: '/audio', built: false },
    { key: 'exports', label: 'Exports', icon: 'export', to: '/exports', built: false },
  ] },
  { title: 'Publishing', items: [
    { key: 'approve', label: 'Approve', icon: 'check', to: '/approve', built: true },
    { key: 'scheduled', label: 'Scheduled', icon: 'calendar', to: '/scheduled', built: true },
    { key: 'published', label: 'Published', icon: 'send', to: '/published', built: true },
  ] },
  { title: 'Brand', items: [
    { key: 'settings', label: 'Settings', icon: 'gear', to: '/settings', built: true },
  ] },
];

export function navForRole(role: StudioRole): NavSection[] {
  const allowed = new Set(ROLE_SECTIONS[role]);
  return NAV.map((s) => ({ ...s, items: s.items.filter((i) => i.built && allowed.has(i.key)) })).filter((s) => s.items.length > 0);
}
